export const detectBrowserLocale = (): string => {
  if (typeof navigator === 'undefined') return '';
  const languages = navigator.languages && navigator.languages.length ? navigator.languages[0] : null;
  return languages || navigator.language || '';
};

export const detectBrowserTimezone = (): string => {
  if (typeof Intl === 'undefined') return '';
  try {
    return Intl.DateTimeFormat().resolvedOptions().timeZone || '';
  } catch {
    return '';
  }
};
